<template>
  <i :class="'yj-icon-' + name"></i>
</template>

<script>
  export default {
    name: 'YjIcon',

    props: {
      name: String
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/icon/src/icon.vue